import { Heading } from '@chakra-ui/react';

const Title = ({ children }: { children: React.ReactNode }) => (
  <Heading as="h3" mb="20px" color="white" fontSize="30px">
    {children}
  </Heading>
);

export default Title;
